<template>
  <article class="card-publication">
    <div class="card-publication__profile">
      <img
        v-if="!isImageError"
        :src="publication.img"
        :alt="publication.name"
        @error="replaceImageToAvatarName"
      >
      <AvatarName
        v-if="isImageError"
        :name="publication.name"
      />
    </div>
    <div class="card-publication__content">
      <div class="card-publication__info">
        <span class="card-publication__profile-name">
          {{ publication.name }}
        </span>
        <span class="card-publication__posted-at">{{ publication.posted_at }}</span>
      </div>
      <div class="card-publication__description">
        <p>
          {{ publication.description }}

          <a
            :href="publication.url"
            class="card-publication__link"
            target="_blank"
            @click="$emit('click-on-see-post')"
          >
            ver publicação
          </a>
        </p>
      </div>
    </div>
  </article>
</template>

<script>
import { AvatarName } from '@/components/base';

export default {
  name: 'CardPublication',
  components: {
    AvatarName,
  },
  props: {
    publication: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isImageError: false,
    };
  },
  methods: {
    replaceImageToAvatarName() {
      this.isImageError = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.card-publication {
  display: grid;
  grid-template-columns: max-content 260px;
  gap: var(--ds-spacing-inline-nano);
  margin-top: var(--ds-spacing-stack-xs);
  margin-bottom: var(--ds-spacing-stack-xs);

  &__profile {
    margin-top: var(--ds-spacing-inline-quark);
    width: var(--ds-spacing-stack-md);
    height: var(--ds-spacing-stack-md);
    border-radius: 50%;
    overflow: hidden;

    img {
      width: 100%;
      border-radius: 50%;
      border: 1px solid var(--ds-color-silver);
    }
  }

  &__profile-name {
    display: inline-block;
    margin-right: var(--ds-spacing-inline-nano);
    font-size: var(--ds-font-size-xs);
    font-weight: var(--ds-font-weight-semibold);
  }

  &__posted-at {
    font-size: var(--ds-font-size-xs);
  }

  &__info {
    margin-bottom: var(--ds-spacing-inline-quark);
  }

  &__description {
    font-size: var(--ds-font-size-xs);
    line-height: var(--ds-font-size-baseline);

    p {
      margin-bottom: 0;
      font-weight: var(--ds-font-weight-semibold);
      color: var(--ds-color-text-1);
    }

    a {
      text-decoration: underline;
    }
  }

  &__link {
    display: block;
  }
}
</style>
